<template>
  <aside>
    <div class="sidebar">
      <div class="nav">
        <el-menu text-color="#fff" active-text-color="#ffd04b" @select="sidebarSelect" :default-active="activeIndex">
          <template v-for="(item,index) in menu">
            <el-menu-item :key="index" :index="item.title">
              <i :class="item.icon"></i>
              <span slot="title">{{item.title}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </aside>
</template>
<script>
import { URL } from '@/config/index';
export default {
  data() {
    return {
      delayTime: 200,
      activeIndex: '数据中心',
      menu: [
        {
          title: '数据中心',
          enable: true,
          icon: 'fa fa-bar-chart fa-lg',
          children: []
        },
        {
          title: '图文资讯',
          enable: true,
          icon: 'fa fa-sign-language fa-lg',
          children: []
        },
        {
          title: '联盟管理',
          enable: true,
          icon: 'fa fa-gear fa-lg',
          children: []
        },
        {
          title: '联盟活动',
          enable: true,
          icon: 'fa fa-gear fa-lg',
          children: []
        },
        {
          title: '成员管理',
          enable: true,
          icon: 'fa fa-group fa-lg',
          children: []
        },
        {
          title: '产品管理',
          enable: true,
          icon: 'fa fa-cube fa-lg',
          children: []
        },
        {
          title: '公共模块管理',
          enable: true,
          icon: 'fa fa-link fa-lg',
          children: []
        }
        // {
        //   title: '单元测试实验室',
        //   enable: true,
        //   icon: 'fa fa-link fa-lg',
        //   children: []
        // }
      ]
    };
  },
  computed: {},
  methods: {
    validatePopedom() {},
    sidebarSelect(key, keyPath, event) {
      this.$router.push({ path: `${URL[key]}` });
    }
  }
};
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/common/adminArea/sidebar.vue